import React from "react";

interface Props {
  onSave: () => void;
  onCancel: () => void;
}

const ProfileActions: React.FC<Props> = ({ onSave, onCancel }) => {
  return (
    <div
      className="flex justify-end gap-3 px-6 py-5
                 bg-blue-50/30 border-t border-blue-50"
    >
      <button
        onClick={onCancel}
        className="px-5 py-2.5 rounded-xl text-xs font-semibold
                   bg-white text-blue-700 border border-blue-200
                   hover:bg-blue-50 hover:-translate-y-0.5
                   transition-all duration-200 cursor-pointer"
      >
        Annuler
      </button>

      <button
        onClick={onSave}
        className="px-5 py-2.5 rounded-xl text-xs font-semibold text-white
                   bg-gradient-to-r from-blue-500 to-blue-400
                   shadow-md shadow-blue-200
                   hover:brightness-105 hover:-translate-y-0.5
                   transition-all duration-200 border-none cursor-pointer"
      >
        Enregistrer les modifications
      </button>
    </div>
  );
};

export default ProfileActions;